/* ZENOVA — animations premium : apparitions au scroll (non-bloquant) */
(function () {
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduce || !('IntersectionObserver' in window)) return;

  document.documentElement.classList.add('zen-anim');

  function init() {
    var vh = window.innerHeight || document.documentElement.clientHeight;
    var sections = document.querySelectorAll('.shopify-section');
    var toObserve = [];

    sections.forEach(function (el) {
      var top = el.getBoundingClientRect().top;
      if (top > vh * 0.85) {
        el.classList.add('zen-reveal');
        toObserve.push(el);
      }
    });

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('zen-in');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });

    toObserve.forEach(function (el) { io.observe(el); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

/* ZENOVA — Cadeaux offerts + upsells intelligents + alerte compatibilité (tiroir + page)
   Chaque cadeau : [nom, valeur barrée (null = sans valeur), badge, once (true = une seule fois, non multiplié)]
   « Cadeau surprise » = guide du drainage (PDF kiné), volontairement non dévoilé dans le panier. */
(function () {
  var SURPRISE = ["Cadeau surprise kiné", 39.9, "OFFERT", true];
  var GARANTIE = ["Garantie constructeur", null, "OFFERTE", true];
  /* Volontairement sobre : 2 lignes maximum (garantie + cadeau surprise), pas de liste de cadeaux. */
  var GIFTS = {
    "bottes-de-pressotherapie-maison": { label: "Pack Essentiel", items: [SURPRISE, GARANTIE] },
    "pack-signature": { label: "Pack Signature", items: [SURPRISE, GARANTIE] },
    "bottes-de-pressotherapie-superieures": { label: "Pack Premium", items: [SURPRISE, GARANTIE] },
    "gouttes-drainantes": { label: "Gouttes drainantes", items: [SURPRISE], light: true }
  };
  var ESSENTIEL = "bottes-de-pressotherapie-maison";
  var PREMIUM = "bottes-de-pressotherapie-superieures";
  var SIGNATURE = "pack-signature";
  var SAC = "sac-de-transport-essentiel";
  var EXTENSIONS = "extensions-pour-pack-signature";
  var ACCESSOIRES = ["manchon-ceinture-de-pressotherapie", "manchons-de-pressotherapie-pour-les-bras", "ceinture-de-pressotherapie-pour-la-taille"];
  function giftFor(handle) {
    if (!handle) return null;
    if (GIFTS[handle]) return GIFTS[handle];
    for (var k in GIFTS) { if (handle.indexOf(k) === 0) return GIFTS[k]; }
    return null;
  }
  function fmt(n) {
    return n.toFixed(2).replace('.', ',').replace(',00', '') + ' €';
  }
  function collect(container, itemSel) {
    var lines = container.querySelectorAll(itemSel);
    var found = [], sig = [], handles = [], packCount = 0, onceSeen = {};
    lines.forEach(function (line) {
      var h = line.getAttribute('data-product-handle');
      handles.push(h);
      var g = giftFor(h);
      if (!g) return;
      if (!g.light) packCount++;
      var qtyInput = line.querySelector('[data-ref="quantity-selector-input"]');
      var qty = qtyInput ? (parseInt(qtyInput.value, 10) || 1) : 1;
      sig.push(h + ':' + qty);
      g.items.forEach(function (it) {
        if (it[3]) {
          if (onceSeen[it[0]]) return;
          onceSeen[it[0]] = true;
          found.push({ name: it[0], value: it[1], qty: 1, badge: it[2] || 'OFFERT', pack: null, once: true });
          return;
        }
        found.push({ name: it[0], value: it[1] * qty, qty: qty, badge: it[2] || 'OFFERT', pack: g.label });
      });
    });
    return { found: found, sig: sig.join('|'), handles: handles, multi: packCount > 1 };
  }
  function render(parent, after, data) {
    var existing = parent.querySelector(':scope > .zgift');
    if (!data.found.length) { if (existing) existing.remove(); return; }
    if (existing && existing.getAttribute('data-sig') === data.sig) return;
    if (existing) existing.remove();
    var el = document.createElement('div');
    el.className = 'zgift';
    el.setAttribute('data-sig', data.sig);
    var rows = data.found.map(function (f) {
      var name = f.name, hi = f.name === 'Cadeau surprise kiné';
      if (hi) name = '<strong style="font-weight:800;color:#1e3a5f;">🎁 ' + name + '</strong>';
      if (data.multi && f.pack) name += ' <span class="zgift__pack">(' + f.pack + ')</span>';
      var val = f.value === null ? '' : '<span class="zgift__val"><s>' + fmt(f.value) + '</s></span>';
      return '<div class="zgift__row"' + (hi ? ' style="background:#fdf1f4;border-radius:8px;padding:5px 7px;margin:0 -7px;"' : '') + '><span class="zgift__name">' + name + (f.qty > 1 && f.value !== null ? ' ×' + f.qty : '') + '</span>' + val + '<span class="zgift__badge">' + f.badge + '</span></div>';
    }).join('');
    el.innerHTML = '<div class="zgift__title">🎁 Vos cadeaux offerts</div>' + rows;
    if (after && after.parentNode === parent) parent.insertBefore(el, after.nextSibling);
    else parent.appendChild(el);
  }
  function has(handles, prefix) {
    return handles.some(function (h) { return h && h.indexOf(prefix) === 0; });
  }
  /* ===== Alerte compatibilité =====
     Essentiel : rien de compatible (à part le sac).
     Signature : compatible uniquement avec les Extensions.
     Premium : compatible uniquement avec les accessoires Premium (manchon / ceinture / duo). */
  function warningsFor(handles) {
    var warns = [];
    var hasEss = has(handles, ESSENTIEL);
    var hasSig = has(handles, SIGNATURE);
    var hasPrem = has(handles, PREMIUM);
    var hasExt = has(handles, EXTENSIONS);
    var hasAcc = ACCESSOIRES.some(function (p) { return has(handles, p); });
    if (hasExt && !hasSig && (hasEss || hasPrem)) {
      warns.push('Les <strong>Extensions +10/+15 cm</strong> sont compatibles <strong>uniquement avec le Pack Signature</strong> — elles ne s\'adaptent pas aux autres packs.');
    }
    if (hasAcc && !hasPrem && (hasEss || hasSig)) {
      warns.push('Le <strong>manchon bras</strong> et la <strong>ceinture</strong> sont compatibles <strong>uniquement avec le Pack Premium</strong> — ils ne se branchent pas sur les autres packs.');
    }
    return warns;
  }
  function renderWarn(parent, before, warns) {
    var existing = parent.querySelector(':scope > .zwarn');
    var sig = warns.join('§');
    if (!warns.length) { if (existing) existing.remove(); return; }
    if (existing && existing.getAttribute('data-sig') === sig) return;
    if (existing) existing.remove();
    var el = document.createElement('div');
    el.className = 'zwarn';
    el.setAttribute('data-sig', sig);
    var rows = warns.map(function (w) {
      return '<div class="zwarn__row">' + w + '</div>';
    }).join('');
    el.innerHTML = '<div class="zwarn__title">⚠️ Articles incompatibles</div>' + rows +
      '<div class="zwarn__hint">Vérifiez votre panier : retirez cet article ou choisissez le pack compatible.</div>';
    if (before && before.parentNode === parent) parent.insertBefore(el, before);
    else parent.insertBefore(el, parent.firstChild);
  }
  function setDisplay(cls, show) {
    document.querySelectorAll(cls).forEach(function (el) {
      el.style.display = show ? '' : 'none';
    });
  }
  function toggleUpsells(handles) {
    var hasAccessoire = ACCESSOIRES.some(function (p) { return has(handles, p); });
    var wantPremium = has(handles, PREMIUM) && !hasAccessoire;
    var wantSignature = has(handles, SIGNATURE) && !has(handles, EXTENSIONS);
    var wantSac = has(handles, ESSENTIEL) && !has(handles, SAC);
    /* Un seul upsell à la fois (priorité : Premium > Signature > Sac)
       pour garder le panier compact, surtout sur mobile. */
    var showPremium = wantPremium;
    var showSignature = !showPremium && wantSignature;
    var showSac = !showPremium && !showSignature && wantSac;
    setDisplay('.zen-premium-upsell', showPremium);
    setDisplay('.zen-signature-upsell', showSignature);
    setDisplay('.zen-sac-upsell', showSac);
  }
  function refresh() {
    var allHandles = [];
    var drawerBody = document.querySelector('.cart-drawer__body');
    if (drawerBody) {
      var d = collect(drawerBody, 'cart-drawer-item[data-product-handle]');
      render(drawerBody, drawerBody.querySelector(':scope > form'), d);
      renderWarn(drawerBody, drawerBody.querySelector(':scope > form'), warningsFor(d.handles));
      allHandles = allHandles.concat(d.handles);
    }
    var form = document.querySelector('.cart__form');
    if (form) {
      var items = form.querySelector('.cart__items');
      if (items) {
        var c = collect(items, 'cart-item[data-product-handle]');
        render(form, items, c);
        renderWarn(items, items.firstChild, warningsFor(c.handles));
        allHandles = allHandles.concat(c.handles);
      }
    }
    toggleUpsells(allHandles);
  }
  var t = null;
  function schedule() { clearTimeout(t); t = setTimeout(refresh, 150); }
  function boot() {
    refresh();
    new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true });
    document.body.addEventListener('change', schedule);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();

/* ZENOVA — Prix (soldé + barré) sous le titre des cartes produits — Collection en vedette */
(function () {
  var cache = {};
  function fmt(cents) {
    return (cents / 100).toFixed(2).replace('.', ',').replace(',00', '') + ' €';
  }
  function inject(card, data) {
    if (card.querySelector('.zprice') || card.querySelector('product-price')) return;
    var group = card.querySelector('.product-card-group');
    if (!group) return;
    var el = document.createElement('div');
    el.className = 'zprice';
    var html = '<span class="zprice__now">' + fmt(data.price) + '</span>';
    if (data.compare_at_price && data.compare_at_price > data.price) {
      html += '<s class="zprice__was">' + fmt(data.compare_at_price) + '</s>';
    }
    el.innerHTML = html;
    var title = group.querySelector('h1, h2, h3, h4, p');
    if (title) {
      var wrap = title;
      while (wrap.parentNode && wrap.parentNode !== group) wrap = wrap.parentNode;
      group.insertBefore(el, wrap.nextSibling);
    } else {
      group.appendChild(el);
    }
  }
  function scan() {
    var cards = document.querySelectorAll('[id*="collection_featured"] .product-card, .collection-featured .product-card');
    cards.forEach(function (card) {
      if (card.querySelector('.zprice') || card.querySelector('product-price')) return;
      var url = card.getAttribute('data-product-url');
      if (!url) {
        var a = card.querySelector('a[href*="/products/"]');
        url = a && a.getAttribute('href');
      }
      if (!url) return;
      var m = url.match(/\/products\/([^\/?#]+)/);
      if (!m) return;
      var handle = m[1];
      var c = cache[handle];
      if (c && c !== 'pending') { inject(card, c); return; }
      if (c === 'pending') return;
      cache[handle] = 'pending';
      fetch('/products/' + handle + '.js')
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (p) {
          if (!p) { delete cache[handle]; return; }
          cache[handle] = { price: p.price, compare_at_price: p.compare_at_price };
          scan();
        })
        .catch(function () { delete cache[handle]; });
    });
  }
  var pt = null;
  function pschedule() { clearTimeout(pt); pt = setTimeout(scan, 200); }
  function pboot() {
    scan();
    new MutationObserver(pschedule).observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', pboot);
  else pboot();
})();
